import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Calendar, MapPin, ArrowRight, Clock } from 'lucide-react';
import api from '../../lib/api';

export default function MemberEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/events').then(({ data }) => setEvents(data || [])).finally(() => setLoading(false));
  }, []);

  const daysUntil = (iso) =>
    Math.max(0, Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000));

  return (
    <div className="space-y-5" data-testid="member-events">
      <div>
        <p className="text-xs font-bold uppercase tracking-wider text-orange-500">Agenda CNIB</p>
        <h1 className="font-heading text-2xl font-extrabold text-slate-900 sm:text-3xl flex items-center gap-2">
          <Calendar className="h-7 w-7 text-cnib-blue" /> Eventos y congresos
        </h1>
        <p className="mt-1 text-sm text-slate-600">Participa de los eventos exclusivos para socios.</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-16">
          <Loader2 className="h-10 w-10 animate-spin text-cnib-blue" />
        </div>
      ) : events.length === 0 ? (
        <div className="rounded-3xl border border-dashed border-slate-300 bg-white py-16 text-center text-sm text-slate-500" data-testid="member-events-empty">
          Aún no hay eventos publicados.
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="member-events-grid">
          {events.map((ev) => {
            const days = daysUntil(ev.starts_at);
            const past = new Date(ev.starts_at).getTime() < Date.now();
            return (
              <Link
                key={ev.slug}
                to={`/eventos/${ev.slug}`}
                data-testid={`member-event-card-${ev.slug}`}
                className="group block overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-xl"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-slate-100">
                  {ev.cover_image && (
                    <img src={ev.cover_image} alt={ev.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-transparent" />
                  {!past ? (
                    <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-orange-500 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white">
                      <Clock className="h-3 w-3" /> En {days} {days === 1 ? 'día' : 'días'}
                    </span>
                  ) : (
                    <span className="absolute left-3 top-3 rounded-full bg-slate-800 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white">
                      Finalizado
                    </span>
                  )}
                </div>
                <div className="p-4">
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">
                    {String(ev.starts_at).slice(0, 10)}
                  </p>
                  <h3 className="mt-1 line-clamp-2 font-heading text-base font-extrabold text-slate-900 group-hover:text-cnib-blue">
                    {ev.title}
                  </h3>
                  {ev.city && (
                    <p className="mt-1 flex items-center gap-1 text-xs text-slate-500">
                      <MapPin className="h-3 w-3" /> {ev.city}
                    </p>
                  )}
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-orange-500">
                    Ver evento <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
